module.exports = __webpack_public_path__ + "static/media/18_zemly_0_85.37.2c4df80a.png";